import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"

export const SearchPageContainer = styled.div`
  /* overflow: hidden; */

  @media ${device.tablet} {
  }

  @media ${device.desktop} {
  }

  .advertisement {
    margin: 40px auto;

    @media ${device.desktop} {
      margin: 55px auto;
    }
  }
`
export const SearchBarContainer = styled.div`
  margin: 0 auto;
  width: ${props => `calc(100% - 2*${props.theme.mobileGutter})`};
  margin-top: 20px;
  max-width: ${props => props.theme.mainMaxWidth};
  position: relative;

  @media ${device.tablet} {
    width: ${props => `calc(100% - 2*${props.theme.desktopGutter})`};
    margin-top: 40px;
  }

  @media ${device.desktop} {
    padding-bottom: 10px;
  }

  @media ${device.large} {
    margin-top: 60px;
  }
`

export const Number = styled.div`
  font-size: 14px;

  @media ${device.desktop} {
    font-size: 16px;
  }

  p {
    display: inline;
  }

  span {
    font-weight: 600;
    color: ${props => props.theme.colors.black};
    text-decoration: none;
  }
`

export const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  margin-left: calc(-50vw + 50%);
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: ${props => (props.isFiltersShown ? "0.3" : "0")};
  z-index: 3;
  pointer-events: ${props => (props.isFiltersShown ? "all" : "none")};

  @media ${device.tablet} {
    display: none;
  }
`

export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-bottom: 10px;
  border-bottom: 3px solid black;
  margin-bottom: 20px;
`

export const Input = styled.input`
  border: 0;
  width: 100px;
  background: none;
  flex-grow: 1;
  flex-shrink: 0;
  font-size: 42px;
  line-height: 100%;
  /* padding-right: 40px; */
  font-weight: 600;
  display: block;
  outline: none;
  font-family: "NeuzeitGro";

  &::placeholder {
    color: ${props => props.theme.colors.grey[1]};
    opacity: 1;
  }

  @media ${device.tablet} {
    font-size: 64px;
  }

  @media ${device.large} {
    font-size: 96px;
  }
`

export const CloseSearch = styled.button`
  background: none;
  outline: none;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  opacity: ${props => (props.queryExists ? 1 : 0)};
  transition: 100ms;
  pointer-events: ${props => (props.queryExists ? "all" : "none")};
  svg {
    margin: 0;
    width: 25px;
    display: block;

    g {
      stroke: ${props => props.theme.colors.grey[2]};
    }

    @media ${device.large} {
      width: 35px;
    }

    :hover {
      g {
        stroke: ${props => props.theme.colors.teal};
      }

      transition: 70ms;
    }
  }
`

export const Container = styled.div`
  @media ${device.tablet} {
    position: absolute;
    width: 100%;
    pointer-events: none;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 23px;
  z-index: 4;
  border-radius: 2px;
  position: relative;
  pointer-events: none;
`

export const TriggerContainer = styled.button`
  height: 50px;
  background: ${props => (props.isFiltersShown ? "#fff" : "#f5f8f8")};
  display: flex;
  align-items: center;
  outline: none;
  justify-content: space-between;
  border: none;
  pointer-events: all;
  cursor: pointer;
  z-index: 3;
  padding: 0 20px;
  span {
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.theme.colors.black};

    &.selected {
      color: #fff;
      margin-left: 12px;
      background: ${props => props.theme.colors.turquoise};
      padding: 5px 8px;
      border-radius: 4px;
    }
  }

  svg {
    width: 16px;
    transform: ${props => (props.isFiltersShown ? "rotateX(180deg);" : "none")};
    transition: 400ms;
  }

  @media ${device.tablet} {
    display: none;
  }
`

export const SelectionIndicator = styled.div``

export const DropDownContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 10px 15px 35px 0 rgba(0, 0, 0, 0.35);
  z-index: 1;
  width: 100%;
  transform: translateY(100%);
  opacity: ${props => (props.isFiltersShown ? 1 : 0)};
  pointer-events: ${props => (props.isFiltersShown ? "all" : "none")};

  @media ${device.tablet} {
    position: relative;
    transform: translateY(0);
    box-shadow: none;
    opacity: 1;
    overflow-y: hidden;
    overflow-x: visible;
    height: ${props => (props.isFiltersShown ? "250px" : "0px")};
    transition-property: height;
    transition-duration: 400ms;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
  }

  @media (min-width: 930px) {
    height: ${props => (props.isFiltersShown ? "210px" : "0px")};
  }

  @media ${device.desktop} {
    height: ${props => (props.isFiltersShown ? "220px" : "0px")};
  }
`
export const FiltersList = styled.ul`
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: 1fr;
  list-style: none;
  margin: 0;
  padding: 20px;
  border-top: ${props => `1px solid ${props.theme.colors.grey[1]}`};

  @media (min-width: 365px) {
    display: ${props => props.var && "flex"};
    justify-content: ${props => props.var && "space-between"};
    max-width: ${props => props.var && "277px"};
    grid-template-rows: repeat(11, auto);
    grid-template-columns: repeat(auto-fit, minmax(120px, auto));
    grid-auto-flow: column;
  }

  @media (min-width: 530px) {
    grid-template-rows: repeat(7, auto);
  }

  @media (min-width: 700px) {
    grid-template-rows: repeat(6, auto);
  }

  @media (min-width: 930px) {
    grid-template-rows: repeat(5, auto);
  }

  @media ${device.tablet} {
    /* position: absolute; */
    width: calc(100% - 80px);
    margin: 0 auto;
    max-width: 1200px;
    border-top: ${props =>
      props.isFiltersShown
        ? `1px solid ${props.theme.colors.grey[1]}`
        : "1px solid transparent"};
    grid-template-columns: repeat(auto-fit, minmax(154px, auto));
    grid-column-gap: ${props => props.theme.desktopGap};
    padding: 0;
    padding-top: 16px;
    transition: border-top 200ms;
    transition-delay: ${props => (props.isFiltersShown ? "0" : "200ms")};
  }
  @media ${device.desktop} {
    display: grid;
    grid-column-gap: 20px;
  }

  @media ${device.large} {
    grid-column-gap: ${props => props.theme.largeGap};
  }
`

export const FilterListItem = styled.li`
  margin: 0;

  :hover {
    span {
      color: ${props => (props.isSelected ? "#fff" : props.theme.colors.teal)};
      transition: 100ms;
    }
  }
`

export const Selected = styled.button`
	text-align: left;
	padding: 0;
	margin-bottom: 0;
	width: 100%;
	outline: none;
	border: none;
	background: none !important;
	cursor: pointer;
	display: inline;
	z-index: 0;
	padding: 7px 0;

	/* :focus {
		span {
			color: ${props => (props.isSelected ? "#fff" : props.theme.colors.teal)};
		} */
	}

	span {
		position: relative;
		font-size: 14px;
		z-index: 4;
		color: ${props => (props.isSelected ? "#fff" : props.theme.colors.black)};
		font-weight: 600;

		::before {
			opacity: ${props => (props.isSelected ? "1" : "0")};
			content: '';
			transition: 110ms;
			position: absolute;
			left: -6px;
			top: -5px;
			width: calc(100% + 14px);
			height: 28px;
			background: ${props => props.theme.colors.turquoise};
			border-radius: 3px;
			z-index: -1;
		}
	}
`

export const ClearAndClose = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  border-top: ${props => `1px solid ${props.theme.colors.grey[1]}`};

  @media ${device.tablet} {
    display: none;
  }
`

export const ClearButton = styled.button`
  display: flex;
  outline: none;
  border: none;
  align-items: center;
  background: none;
  cursor: pointer;
  pointer-events: all;
  padding: 0;
  padding-right: 20px;
  svg {
    width: 15px;
    margin-right: 10px;

    g {
      stroke: ${props => props.theme.colors.grey[2]};
    }
  }

  span {
    font-size: 12px;
    font-weight: 600;
    color: ${props => props.theme.colors.grey[2]};
  }
`

export const CloseButton = styled.button`
  display: inline-flex;
  background: ${props => props.theme.colors.pink};
  border-radius: 2px;
  font-weight: 600;
  outline: none;
  border: none;
  font-size: 14px;
  padding: 0 18px;
  height: 40px;
  width: 120px;
  color: white;
  cursor: pointer;
  justify-content: center;
  text-align: center;
  align-items: center;

  :hover {
    background: #c8295f;
    transition: 70ms;
  }
`

export const TopPagination = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 40px;
  width: ${props => `calc(100% - 2 *${props.theme.mobileGutter})`};

  @media ${device.tablet} {
    margin-top: 57px;
  }

  @media ${device.desktop} {
    margin-top: 105px;
    padding-bottom: 16px;
    position: absolute;
    top: 0;
    right: 0;
    justify-content: flex-end;
    width: 100%;
    border-bottom: ${props => `1px solid ${props.theme.colors.grey[1]}`};
  }
  @media ${device.large} {
    margin-top: 140px;
  }
  .container {
    height: 30px;
  }

  .button {
    width: 55px;
  }
`

export const TopIndicator = styled.div`
  display: ${props => (props.hide ? "none" : "block")};
  max-width: ${props => props.theme.mainMaxWidth};
  margin: 0 auto;
  width: ${props => `calc(100% - 2 *${props.theme.mobileGutter})`};

  @media ${device.tablet} {
    width: ${props => `calc(100% - 2 *${props.theme.desktopGutter})`};
  }
`

export const BottomPagination = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-top: ${props =>
    props.category && `1px solid ${props.theme.colors.grey[1]}`};
  padding-top: ${props => props.category && "22px"};
  max-width: ${props => props.theme.mainMaxWidth};
  margin: 0 auto;
  width: ${props => `calc(100% - 2 *${props.theme.mobileGutter})`};
  @media ${device.tablet} {
    padding-top: ${props => props.category && "26px"};

    width: ${props => `calc(100% - 2 *${props.theme.desktopGutter})`};
  }
  @media ${device.desktop} {
    padding-top: ${props => props.category && "56px"};
    justify-content: ${props => (props.category ? "flex-end" : "flex-end")};
    flex-direction: row;
  }

  @media ${device.large} {
    padding-top: ${props => props.category && "54px"};
  }

  .number {
    margin-bottom: 20px;
    @media ${device.desktop} {
      margin: 0;
      margin-right: 25px;
      align-self: flex-end;
      margin-bottom: 8px;

      p {
        display: inline-block;
        margin-bottom: 0;
      }
    }
  }
`

export const CatFilterTrigger = styled.div`
	display: none;

	@media ${device.tablet} {
		position: absolute;
		display: flex;
		align-items: center;
		right: 0;
		top: -20px;
		padding-bottom: 20px;
		cursor: pointer;
		pointer-events:all;

		svg:first-of-type {
			width: 14px;
			margin: 0;
			margin-right: 12PX;
			path {
				fill: ${props =>
          props.isFiltersShown || props.hasFilters
            ? props.theme.colors.turqoise
            : "#9CACAE"};
			}
		}

		svg:last-of-type {
			margin: 0;
			width: 12px;
			transform: ${props => (props.isFiltersShown ? "rotateX(180deg);" : "none")};
			transition: 300ms;

			path {
				stroke: ${props =>
          props.isFiltersShown || props.hasFilters
            ? props.theme.colors.teal
            : "#9CACAE"};
			}
		}

		p {
			font-size: 14px;
			margin: 0;
			color: ${props =>
        props.isFiltersShown || props.hasFilters
          ? props.theme.colors.teal
          : "#19191A"};
			margin-right: 7px;
			font-weight: 600;
		}
	}

	@media ${device.desktop} {
		svg:first-of-type {
			width: 16px;
		}

		svg:last-of-type {
			width: 13px;
		}

		p {
			font-size: 16px;
		}
	}

	::after {
		opacity: ${props => (props.isFiltersShown ? 1 : 0)};
		width: 100%;
		height: 4px;
		background: ${props => props.theme.colors.turquoise};
		bottom: -6px;
		z-index: 5;
		left: 0;
		content: '';
		transition: 400ms;
		pointer-events: none;
		position: absolute;

	@media ${device.desktop} {
		bottom: -4px;


	}
	}
	:hover {
		/* svg:first-of-type {
			path {
				fill: ${props => props.theme.colors.turquoise};
			}
		} */
		svg:last-of-type {
			path {
				stroke: ${props => props.theme.colors.teal};
			}
		}

		/* p {
			color: ${props => props.theme.colors.teal};
		} */
	}
`

export const BoxShadow = styled.div`
  display: none;
  @media ${device.tablet} {
    opacity: ${props => (props.isFiltersShown ? 1 : 0)};
    display: block;
    position: absolute;
    right: 50%;
    bottom: 0;
    transition-delay: ${props => (props.isFiltersShown ? "0" : "250ms")};
    transition-duration: 200ms;

    transform: translateX(50%);
    height: 1000px;
    z-index: 4;
    width: calc(100vw);
    border-bottom: 1px solid #d7e1e2;
    box-shadow: 0 25px 25px 0 rgba(0, 0, 0, 0.05);
    pointer-events: none;
  }
`
